// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__hjIiz","list":"BalanceDue_list__26ex8","listRow":"BalanceDue_listRow__f_Zx1","total":"BalanceDue_total__3AJaA"};